import _wellKnownSymbol from "../internals/well-known-symbol";
var exports = {};
var wellKnownSymbol = _wellKnownSymbol;
var TO_STRING_TAG = wellKnownSymbol("toStringTag");
var test = {};
test[TO_STRING_TAG] = "z";
exports = String(test) === "[object z]";
export default exports;